import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { HouseModel } from "../base-house-relation/base-house-relation.component";
@Component({
  selector: "host-house-relation-house-card",
  templateUrl: "./house-relation-house-card.component.html",
  styleUrls: ["./house-relation-house-card.component.scss"],
})
export class HouseRelationHouseCardComponent implements OnInit {
  @Input() houseInfo: HouseModel;
  @Output() onDelete = new EventEmitter();
  constructor() {}

  ngOnInit() {}
}
